import React, { useState, useEffect, useRef } from 'react';

const INTERACTIVE_SELECTORS = '[data-interactive], button, a, .desktop-icon, .project-card, .contact-link, .start-menu-item, .taskbar-window-btn, .win-btn';

const isTouchDevice = () =>
  'ontouchstart' in window || navigator.maxTouchPoints > 0;

const CustomCursor = () => {
  const cursorRef = useRef(null);
  const cursorRingRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);
  const [isClicking, setIsClicking] = useState(false);
  const [isTouch, setIsTouch] = useState(true); // Default true to prevent flash

  useEffect(() => {
    setIsTouch(isTouchDevice());
  }, []);

  useEffect(() => {
    if (isTouch) return;

    const cursor = cursorRef.current;
    const ring = cursorRingRef.current;

    let mouseX = 0, mouseY = 0;
    let ringX = 0, ringY = 0;
    let animationId;

    const moveCursor = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (cursor) {
        cursor.style.left = mouseX + 'px';
        cursor.style.top = mouseY + 'px';
      }
    };

    const animateRing = () => {
      ringX += (mouseX - ringX) * 0.15;
      ringY += (mouseY - ringY) * 0.15;
      if (ring) {
        ring.style.left = ringX + 'px';
        ring.style.top = ringY + 'px';
      }
      animationId = requestAnimationFrame(animateRing);
    };

    const handleMouseOver = (e) => {
      setIsHovering(!!e.target.closest(INTERACTIVE_SELECTORS));
    };

    const handleMouseDown = () => setIsClicking(true);
    const handleMouseUp = () => setIsClicking(false);

    window.addEventListener('mousemove', moveCursor);
    window.addEventListener('mouseover', handleMouseOver);
    window.addEventListener('mousedown', handleMouseDown);
    window.addEventListener('mouseup', handleMouseUp);
    animationId = requestAnimationFrame(animateRing);

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('mousemove', moveCursor);
      window.removeEventListener('mouseover', handleMouseOver);
      window.removeEventListener('mousedown', handleMouseDown);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isTouch]);

  // Don't render on touch devices
  if (isTouch) return null;

  const cursorClass = `custom-cursor ${isHovering ? 'hovering' : ''} ${isClicking ? 'clicking' : ''}`;
  const ringClass = `cursor-ring ${isHovering ? 'hovering' : ''} ${isClicking ? 'clicking' : ''}`;

  return (
    <>
      <div ref={cursorRef} className={cursorClass} />
      <div ref={cursorRingRef} className={ringClass} />
    </>
  );
};

export default CustomCursor;
